<template>
  <b-container fluid>
    <iq-card>
      <template v-slot:headerTitle>
        <h4 class="card-title title-typography-color">
          <i class="fas fa-list"></i>
          Lista pacientes
        </h4>
      </template>
      <template v-slot:headerAction>
        <b-button class="mr-1" variant="success" @click="download">
          Descarga
        </b-button>
        <b-button class="mr-1" variant="success" @click="openModalUpload">
          Subir
        </b-button>
        <b-button class="mr-1" variant="success" @click="openModal('CREATE', null)">
          {{ $t("public.views.Pages.Alert.create") }}
        </b-button>
        <b-button class="mr-2" style="right" variant="primary" @click="goToAlert">Volver
        </b-button>
      </template>
      <template v-slot:body>
        <div>
          <v-data-table v-model="patients" :footer-props="{
            showFirstLastPage: true,
            firstIcon: 'fas fa-arrow-left',
            lastIcon: 'fas fa-arrow-right',
            prevIcon: 'fas fa-minus',
            nextIcon: 'fas fa-plus',
            'items-per-page-options': [10, 25, 50],
          }" :headers="headers" :items="listPatients" :options.sync="pagination" :search="search"
            :server-items-length="total" item-key="id">
            <template v-slot:item.patients="{ item }">
              <b-list-group-item v-for="patient in item.patients" :key="patient.id"
                class="d-flex align-items-center border-0 p-0">
                <b-avatar v-bind:src="
                  patient.avatarUrl
                    ? patient.avatarUrl +
                    '/' +
                    getAuthentication()
                    : ''
                "></b-avatar>
                <div class="media-support-info ml-3">
                  <p class="mb-0 font-size-16">{{ patient.name }}</p>
                  <p class="mb-0 font-size-12">{{ patient.lastname }}</p>
                </div>
              </b-list-group-item>
            </template>
            <template v-slot:item.actions="{ item }">
              <div class="div-table-data">
                <!--           <button
                  :id="'btnUpdate' + item.id"
                  v-on:click="openModal('UPDATE', item.id)"
                  class="item"
                >
                  <i class="ri-file-edit-line"></i>
                </button>
                <b-popover
                  :target="'btnUpdate' + item.id"
                  triggers="hover focus"
                  placement="botton"
                >
                  <template #title>Actualizar</template>
                </b-popover> -->
                <button :id="'btnDelete' + item.id" class="item" v-on:click="deleteItem(item.id)">
                  <i class="ri-delete-bin-line"></i>
                </button>
                <b-popover :target="'btnDelete' + item.id" placement="botton" triggers="hover focus">
                  <template #title>Borrar</template>
                </b-popover>
              </div>
            </template>
          </v-data-table>
        </div>
      </template>
    </iq-card>
    <b-modal id="modal-upload" centered hide-footer size="lg" @ok="saveForm">
      <template #modal-title> Subir Lista pacientes (EXCEL)</template>
      <template #modal-cancel>{{
        $t("public.views.Pages.Alert.modalCreate.btnClose")
      }}
      </template>
      <b-container>
        <b-form-group>
          <vue-dropzone id="picture" :options="dropzoneOptions" @vdropzone-success="vdropzoneSuccess"
            @vdropzone-error="vdropzoneError"></vue-dropzone>
        </b-form-group>
      </b-container>
    </b-modal>
    <b-modal id="modal" centered size="lg" @ok="saveForm">
      <template #modal-title> Lista pacientes</template>
      <template #modal-cancel>{{
        $t("public.views.Pages.Alert.modalCreate.btnClose")
      }}
      </template>
      <template #modal-ok>
        <div v-if="action === 'CREATE'">Crear</div>
        <div v-if="action === 'UPDATE'">Actualizar</div>
      </template>
      <b-container>
        <b-form-group label-for="name">
          <template slot="label"> Nombre: *</template>
          <b-form-input id="name" v-model="name" :disabled="disabled" type="text" v-bind:class="{
            'text-danger': isFormNameErrors,
            'is-invalid': isFormNameErrors,
          }" @blur="checkName(name)"></b-form-input>
          <ul v-if="isFormNameErrors">
            <li v-for="(error, index) in validatorStep1.getErrors('name')" v-bind:key="index"
              class="form-text text-danger">
              &nbsp;{{ error }}
            </li>
          </ul>
        </b-form-group>
        <b-form-group label-for="patients">
          <template slot="label">
            {{ $t("public.views.Pages.Alert.modalCreate.patients") }}:
            *
          </template>

          <multiselect v-model="patients" :clear-on-select="false" :close-on-select="false" :disabled="disabled"
            :multiple="true" :options="patientsSelect" :preselect-first="false" :preserve-search="true" label="text"
            track-by="value" v-bind:deselectGroupLabel="
              $t('public.views.Pages.Alert.multiselect.deselectGroupLabel')
            " v-bind:deselectLabel="
  $t('public.views.Pages.Alert.multiselect.deselectLabel')
" v-bind:placeholder="
  $t('public.views.Pages.Alert.multiselect.placeholder')
" v-bind:selectGroupLabel="
  $t('public.views.Pages.Alert.multiselect.selectGroupLabel')
" v-bind:selectLabel="
  $t('public.views.Pages.Alert.multiselect.selectLabel')
" v-bind:selectedLabel="
  $t('public.views.Pages.Alert.multiselect.selectedLabel')
">
            <template slot="option" slot-scope="props">
              <b-list-group-item class="d-flex align-items-center">
                <b-avatar class="mr-3" v-bind:src="props.option.avatar"></b-avatar>
                <span class="mr-auto title-typography-color">{{
                  props.option.text
                }}</span>
              </b-list-group-item>
            </template>
            <template slot="selection" slot-scope="{ values, isOpen }"><span v-if="values.length && !isOpen"
                class="multiselect__single">{{ values.length }}
                {{
                  $t("public.views.Pages.Alert.multiselect.selectedPatients")
                }}</span></template>
            <template v-if="props.option.text" slot="singleLabel" slot-scope="props"><span class="option__desc"><span
                  class="option__title">
                  <b-avatar class="mr-3" v-bind:src="props.option.avatar"></b-avatar><span
                    class="mr-auto title-typography-color">{{
                      props.option.text
                    }}</span>
                </span></span></template>
          </multiselect>

          <ul v-if="isFormPatientsErrors">
            <li v-for="(error, index) in validatorStep1.getErrors('patients')" v-bind:key="index"
              class="form-text text-danger">
              &nbsp;{{ error }}
            </li>
          </ul>
        </b-form-group>

        <b-form-group label-for="description">
          <template slot="label">Descripción:</template>
          <b-form-textarea id="description" v-model="description" :disabled="disabled" max-rows="6"
            rows="3"></b-form-textarea>
        </b-form-group>
      </b-container>
    </b-modal>
    <notifications group="notificacions" />
  </b-container>
</template>
<script>
import { xray } from "../../../../config/pluginInit";

import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/es";

import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";

import validator from "vue-m-validator";

import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";

import { saveAs } from "file-saver";

import patientService from "../../../../services/patient";
import listPatientService from "../../../../services/listPatient";
import utilsService from "../../../../services/utils";

export default {
  name: "ListPatient",
  mounted() {
    xray.index();
    this.getAll();
    this.getAllPatientsSelect();

    utilsService.auditActivity({ action: "VIEW", module: "PROFESSIONAL_LIST_PATIENT", info: "" });
  },
  watch: {
    pagination: {
      handler() {
        if (this.start) {
          this.getAll();
        }
        this.start = true;
      },
    },
  },
  computed: {
    isFormPatientsErrors() {
      let errors = this.validatorStep1.getErrors("patients");
      return errors && errors.length > 0;
    },
    isFormNameErrors() {
      let errors = this.validatorStep1.getErrors("name");
      return errors && errors.length > 0;
    },
  },
  methods: {
    getAuthentication() {
      return localStorage.getItem('authorization');
    },
    download() {
      saveAs(this.pdfLink, "template_list.xlsx");
    },
    openModalUpload() {
      this.$bvModal.show("modal-upload");
    },
    deleteItem(id) {
      let self = this;
      this.$awn.asyncBlock(
        listPatientService.delete(id),
        (response) => {
          if (response) {
            utilsService.auditActivity({ action: "DELETE", module: "PROFESSIONAL_LIST_PATIENT", info: "" });
            self.getAll();
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "listPatientService.delete",
            module: "view-pages-professional-contact-listPatient",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              id: id
            })
          });
        },
        " "
      );
    },
    get(id) {
      let self = this;
      this.$awn.asyncBlock(
        listPatientService.get(id),
        (response) => {
          if (response) {
            self.id = response.data.id;
            self.name = response.data.name;
            self.description = response.data.description;

            let listReturn = [];

            if (response.data.patients && response.data.patients.length > 0) {
              response.data.patients.forEach(function (item) {
                listReturn.push(
                  self.patientsSelect.find((option) => option.value === item.id)
                );
              });
            }

            self.patients = listReturn;
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "listPatientService.get",
            module: "view-pages-professional-contact-listPatient",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              id: id
            })
          });
        },
        " "
      );
    },
    checkPatients(_item) {
      const ITEM = _item;
      const RULE_1 = {
        expression: ITEM.length === 0,
        name: "patients",
        msg: this.$i18n.t("public.views.Pages.Alert.errors.erPatients"),
      };
      this.validatorStep1.addRule(RULE_1);
      this.notFirst();
    },
    checkName(_item) {
      const ITEM = _item;
      const RULE_1 = {
        expression: ITEM === "",
        name: "name",
        msg: "El nombre no puede ser vacío",
      };
      this.validatorStep1.addRule(RULE_1);
      this.notFirst();
    },
    cleanForm() {
      this.name = "";
      this.patients = [];
      this.description = "";
      this.id = "";
    },
    checkForm() {
      this.checkName(this.name);
      this.checkPatients(this.patients);
    },
    saveForm(evt) {
      evt.preventDefault();

      this.checkForm();

      if (this.validatorStep1.errors.length === 0) {
        this.save();
      } else {
        this.$notify({
          group: "notificacions",
          title: this.$i18n.t("public.views.Pages.Alert.notification.error"),
          text: this.$i18n.t(
            "public.views.Pages.Alert.notification.descErrorCreate"
          ),
          type: "error",
        });
      }
    },
    save() {
      let self = this;

      let patientIds = [];

      if (this.patients && this.patients.length !== 0) {
        this.patients.forEach(function (patient) {
          patientIds.push(patient.value);
        });
      }

      if (this.action === "CREATE") {
        let data = {
          name: this.name,
          description: this.description,
          patients: patientIds,
        };

        this.$awn.asyncBlock(
          listPatientService.create(data),
          (response) => {
            if (response) {
              utilsService.auditActivity({ action: "CREATE", module: "PROFESSIONAL_LIST_PATIENT", info: "" });
              this.$notify({
                group: "notificacions",
                title: "Exito",
                text: "Se ha creado correctamente",
                type: "success",
              });
              this.$bvModal.hide("modal");
              self.getAll();
            }
          },
          (error) => {
            utilsService.auditErrorFrontent({
              info: "listPatientService.create",
              module: "view-pages-professional-contact-listPatient",
              httpStatus: error.response ? error.response.status : null,
              endpoint: window.location.href,
              request: JSON.stringify({
                data: data
              })
            });
          },
          " "
        );
      } else if (this.action === "UPDATE") {
        let data = {
          id: this.id,
          name: this.name,
          description: this.description,
          patients: patientIds,
        };
        this.$awn.asyncBlock(
          listPatientService.update(data),
          (response) => {
            if (response) {
              utilsService.auditActivity({ action: "UPDATE", module: "PROFESSIONAL_LIST_PATIENT", info: "" });
              this.$notify({
                group: "notificacions",
                title: "Exito",
                text: "Se ha actulizado correctamente",
                type: "success",
              });
              this.$bvModal.hide("modal");
              self.getAll();
            }
          },
          (error) => {
            utilsService.auditErrorFrontent({
              info: "listPatientService.update",
              module: "view-pages-professional-contact-listPatient",
              httpStatus: error.response ? error.response.status : null,
              endpoint: window.location.href,
              request: JSON.stringify({
                data: data
              })
            });
          },
          " "
        );
      }
    },
    async getAllPatientsSelect() {
      let self = this;

      patientService
        .getAllActive()
        .then((response) => {
          let combo = [];
          response.data.forEach(function (item) {
            let data = {
              avatar: item.avatarUrl
                ? item.avatarUrl + "/" + localStorage.getItem("authorization")
                : "",
              value: item.email,
              text:
                item.name + " " + item.lastname + " (" + item.document + ") ",
              phone: item.phone,
              email: item.email,
            };
            combo.push(data);
          });
          self.patientsSelect = combo;
        })
        .catch((error) => {
          utilsService.auditErrorFrontent({
            info: "patientService.getAllActive",
            module: "view-pages-professional-contact-listPatient",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: null
          });
        });
    },
    openModal(action, id) {
      this.action = action;

      if (action === "CREATE") {
        this.cleanForm();
        this.$bvModal.show("modal");
      } else if (action === "UPDATE") {
        this.cleanForm();
        this.get(id);
        this.$bvModal.show("modal");
      }
    },
    goToAlert() {
      this.$router.push({
        name: "auth.alert",
      });
    },
    async getAll() {
      let self = this;

      this.$awn.asyncBlock(
        listPatientService.getAllPagination(
          this.pagination.page - 1,
          this.pagination.itemsPerPage
        ),
        (response) => {
          if (response) {
            self.listPatients = response.data.content;
            self.total = response.data.pageable.total;
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "listPatientService.getAllPagination",
            module: "view-pages-professional-contact-listPatient",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              page: this.pagination.page - 1,
              itemsPerPage: this.pagination.itemsPerPage
            })
          });
        },
        " "
      );
    },
    notFirst() {
      this.isFirstRun = false;
    },
    vdropzoneError(file, response) {
      this.$notify({
        group: "notificacions",
        title: "Error",
        text: "Hay errores en el excel que esta intentando subir",
        type: "error",
      });
      this.$bvModal.hide("modal-upload");
    },
    vdropzoneSuccess(file, response) {
      this.$notify({
        group: "notificacions",
        title: "Exito",
        text: "Se ha creado correctamente",
        type: "success",
      });
      this.$bvModal.hide("modal-upload");
      this.getAll();
    },
  },
  data() {
    return {
      start: false,
      pdfLink: require("@/assets/files/template_list.xlsx"),
      dropzoneOptions: {
        url: process.env.VUE_APP_BASE_URL_CORE + "auth/listPatient/excel",
        thumbnailWidth: 200,
        maxFilesize: 2,
        addRemoveLinks: false,
        maxFiles: 1,
        acceptedFiles: ".xlsx",
        dictDefaultMessage: "<i class='ri-upload-cloud-fill'></i>Subir EXCEL",
        headers: { authorization: localStorage.getItem("authorization") },
      },
      total: 0,
      pagination: {},
      pageSize: 10,
      currentPage: 1,

      search: "",

      validatorStep1: validator,

      listPatient: {},

      id: "",
      patients: [],
      name: "",
      description: "",

      patientsSelect: [],
      listPatients: [],
      disabled: false,

      headers: [
        {
          text: "Nombre",
          value: "name",
        },
        {
          text: "Descripcion",
          align: "start",
          value: "description",
        },
        {
          text: "Pacientes",
          value: "patients",
        },
        {
          text: "",
          value: "actions",
        },
      ],

      //Validate
      validator: validator,
      //Data validate form
      isFirstRun: true,
      isValidate: false,
    };
  },

  components: {
    DatePicker,
    Multiselect,
    "vue-dropzone": vue2Dropzone,
  },
};
</script>
